import { useMutation,useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import axiosInstance from '../functions/AxiosInstance'; // Asegúrate de que la ruta sea correcta


interface UserData {
  name: string;
  email: string;
  password: string;
  confirmPassword: string;
}

export const useRegisterUser = () => {
    const mutation = useMutation({
      mutationFn: async (userData: UserData) => {
        const response = await axiosInstance.post('/pixel-users/register', userData);
        return response.data;
      },
      onSuccess: () => {
        toast.success('Usuario registrado con éxito.');
      },
      onError: (error: any) => {
        const errorMessage = error.response?.data?.message || 'Error desconocido';
        toast.error(`Error al registrar usuario: ${errorMessage}`);
        console.error('Error al registrar usuario:', errorMessage);
      },
    });
  
    return {
      ...mutation,
      isLoading: mutation.isPending, // `isPending` is the correct property for mutations
      isSuccess: mutation.isSuccess,
    };
  };








// Función para obtener la información del usuario autenticado
const fetchAuthenticatedUser = async () => {
    const response = await axiosInstance.get('/pixel-users/me', { withCredentials: true });
    return response.data;
};

// Hook personalizado para obtener la información del usuario autenticado
export const useAuthenticatedUser = () => {
    return useQuery({
        queryKey: ['current-user'], // Clave de cacheo
        queryFn: fetchAuthenticatedUser, // Función que hace la consulta
        staleTime: 5 * 60 * 1000, // 5 minutos antes de marcar los datos como obsoletos
        cacheTime: 30 * 60 * 1000, // Cachea los datos durante 30 minutos
        retry: 1, // Reintenta una vez en caso de error
        enabled: true, // Se ejecuta automáticamente al renderizar
    });
};



// Hook para eliminar la cuenta del usuario autenticado
export const useDeleteUserAccount = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async () => {
            const response = await axiosInstance.delete('/pixel-users/me', { withCredentials: true });
            return response.data;
        },
        onSuccess: () => {
            toast.success('Cuenta eliminada con éxito.');
            queryClient.invalidateQueries(['current-user']); // Invalida la consulta del usuario autenticado
        },
        onError: (error) => {
            const errorMessage = error.response?.data?.message || 'Error desconocido';
            toast.error(`Error al eliminar la cuenta: ${errorMessage}`);
            console.error('Error al eliminar la cuenta:', errorMessage);
        },
    });
};


// Hook para verificar si el usuario está autenticado
export const useVerifyAuth = () => {
    return useQuery({
        queryKey: ['auth-status'],
        queryFn: async () => {
            try {
                const response = await axiosInstance.get('/verify-auth', { withCredentials: true });
                return response.data;
            } catch (error) {
                console.error('Error verificando autenticación:', error);
                throw new Error(error.response?.data?.message || 'Error al verificar autenticación');
            }
        },
        staleTime: 1000 * 60 * 5, // Cache de 5 minutos
        retry: 1, // Reintentar una vez en caso de fallo
        select: (data) => ({
            isAuthenticated: data.authenticated,
            user: data.user || null,
            message: data.message,
        }),
        onError: (error) => {
            toast.error(error.message);
        },
    });
};
